export default {
  name: 'ionicons-v4',
  icons: [
    { name: 'ion-ios-add', tags: [] },
    { name: 'ion-ios-add-circle', tags: [] },
    { name: 'ion-ios-add-circle-outline', tags: [] },
    { name: 'ion-ios-airplane', tags: [] },
    { name: 'ion-ios-alarm', tags: [] },
    { name: 'ion-ios-albums', tags: [] },
    { name: 'ion-ios-alert', tags: [] },
    { name: 'ion-ios-american-football', tags: [] },
    { name: 'ion-ios-analytics', tags: [] },
    { name: 'ion-ios-aperture', tags: [] },
    { name: 'ion-ios-apps', tags: [] },
    { name: 'ion-ios-appstore', tags: [] },
    { name: 'ion-ios-archive', tags: [] },
    { name: 'ion-ios-arrow-back', tags: [] },
    { name: 'ion-ios-arrow-down', tags: [] },
    { name: 'ion-ios-arrow-dropdown', tags: [] },
    { name: 'ion-ios-arrow-dropdown-circle', tags: [] },
    { name: 'ion-ios-arrow-dropleft', tags: [] },
    { name: 'ion-ios-arrow-dropleft-circle', tags: [] },
    { name: 'ion-ios-arrow-dropright', tags: [] },
    { name: 'ion-ios-arrow-dropright-circle', tags: [] },
    { name: 'ion-ios-arrow-dropup', tags: [] },
    { name: 'ion-ios-arrow-dropup-circle', tags: [] },
    { name: 'ion-ios-arrow-forward', tags: [] },
    { name: 'ion-ios-arrow-round-back', tags: [] },
    { name: 'ion-ios-arrow-round-down', tags: [] },
    { name: 'ion-ios-arrow-round-forward', tags: [] },
    { name: 'ion-ios-arrow-round-up', tags: [] },
    { name: 'ion-ios-arrow-up', tags: [] },
    { name: 'ion-ios-at', tags: [] },
    { name: 'ion-ios-attach', tags: [] },
    { name: 'ion-ios-backspace', tags: [] },
    { name: 'ion-ios-barcode', tags: [] },
    { name: 'ion-ios-baseball', tags: [] },
    { name: 'ion-ios-basket', tags: [] },
    { name: 'ion-ios-basketball', tags: [] },
    { name: 'ion-ios-battery-charging', tags: [] },
    { name: 'ion-ios-battery-dead', tags: [] },
    { name: 'ion-ios-battery-full', tags: [] },
    { name: 'ion-ios-beaker', tags: [] },
    { name: 'ion-ios-bed', tags: [] },
    { name: 'ion-ios-beer', tags: [] },
    { name: 'ion-ios-bicycle', tags: [] },
    { name: 'ion-ios-bluetooth', tags: [] },
    { name: 'ion-ios-boat', tags: [] },
    { name: 'ion-ios-body', tags: [] },
    { name: 'ion-ios-bonfire', tags: [] },
    { name: 'ion-ios-book', tags: [] },
    { name: 'ion-ios-bookmark', tags: [] },
    { name: 'ion-ios-bookmarks', tags: [] },
    { name: 'ion-ios-bowtie', tags: [] },
    { name: 'ion-ios-briefcase', tags: [] },
    { name: 'ion-ios-browsers', tags: [] },
    { name: 'ion-ios-brush', tags: [] },
    { name: 'ion-ios-bug', tags: [] },
    { name: 'ion-ios-build', tags: [] },
    { name: 'ion-ios-bulb', tags: [] },
    { name: 'ion-ios-bus', tags: [] },
    { name: 'ion-ios-business', tags: [] },
    { name: 'ion-ios-cafe', tags: [] },
    { name: 'ion-ios-calculator', tags: [] },
    { name: 'ion-ios-calendar', tags: [] },
    { name: 'ion-ios-call', tags: [] },
    { name: 'ion-ios-camera', tags: [] },
    { name: 'ion-ios-car', tags: [] },
    { name: 'ion-ios-card', tags: [] },
    { name: 'ion-ios-cart', tags: [] },
    { name: 'ion-ios-cash', tags: [] },
    { name: 'ion-ios-cellular', tags: [] },
    { name: 'ion-ios-chatboxes', tags: [] },
    { name: 'ion-ios-chatbubbles', tags: [] },
    { name: 'ion-ios-checkbox', tags: [] },
    { name: 'ion-ios-checkbox-outline', tags: [] },
    { name: 'ion-ios-checkmark', tags: [] },
    { name: 'ion-ios-checkmark-circle', tags: [] },
    { name: 'ion-ios-checkmark-circle-outline', tags: [] },
    { name: 'ion-ios-clipboard', tags: [] },
    { name: 'ion-ios-clock', tags: [] },
    { name: 'ion-ios-close', tags: [] },
    { name: 'ion-ios-close-circle', tags: [] },
    { name: 'ion-ios-close-circle-outline', tags: [] },
    { name: 'ion-ios-cloud', tags: [] },
    { name: 'ion-ios-cloud-circle', tags: [] },
    { name: 'ion-ios-cloud-done', tags: [] },
    { name: 'ion-ios-cloud-download', tags: [] },
    { name: 'ion-ios-cloud-outline', tags: [] },
    { name: 'ion-ios-cloud-upload', tags: [] },
    { name: 'ion-ios-cloudy', tags: [] },
    { name: 'ion-ios-cloudy-night', tags: [] },
    { name: 'ion-ios-code', tags: [] },
    { name: 'ion-ios-code-download', tags: [] },
    { name: 'ion-ios-code-working', tags: [] },
    { name: 'ion-ios-cog', tags: [] },
    { name: 'ion-ios-color-fill', tags: [] },
    { name: 'ion-ios-color-filter', tags: [] },
    { name: 'ion-ios-color-palette', tags: [] },
    { name: 'ion-ios-color-wand', tags: [] },
    { name: 'ion-ios-compass', tags: [] },
    { name: 'ion-ios-construct', tags: [] },
    { name: 'ion-ios-contact', tags: [] },
    { name: 'ion-ios-contacts', tags: [] },
    { name: 'ion-ios-contract', tags: [] },
    { name: 'ion-ios-contrast', tags: [] },
    { name: 'ion-ios-copy', tags: [] },
    { name: 'ion-ios-create', tags: [] },
    { name: 'ion-ios-crop', tags: [] },
    { name: 'ion-ios-cube', tags: [] },
    { name: 'ion-ios-cut', tags: [] },
    { name: 'ion-ios-desktop', tags: [] },
    { name: 'ion-ios-disc', tags: [] },
    { name: 'ion-ios-document', tags: [] },
    { name: 'ion-ios-done-all', tags: [] },
    { name: 'ion-ios-download', tags: [] },
    { name: 'ion-ios-easel', tags: [] },
    { name: 'ion-ios-egg', tags: [] },
    { name: 'ion-ios-exit', tags: [] },
    { name: 'ion-ios-expand', tags: [] },
    { name: 'ion-ios-eye', tags: [] },
    { name: 'ion-ios-eye-off', tags: [] },
    { name: 'ion-ios-fastforward', tags: [] },
    { name: 'ion-ios-female', tags: [] },
    { name: 'ion-ios-filing', tags: [] },
    { name: 'ion-ios-film', tags: [] },
    { name: 'ion-ios-finger-print', tags: [] },
    { name: 'ion-ios-fitness', tags: [] },
    { name: 'ion-ios-flag', tags: [] },
    { name: 'ion-ios-flame', tags: [] },
    { name: 'ion-ios-flash', tags: [] },
    { name: 'ion-ios-flash-off', tags: [] },
    { name: 'ion-ios-flashlight', tags: [] },
    { name: 'ion-ios-flask', tags: [] },
    { name: 'ion-ios-flower', tags: [] },
    { name: 'ion-ios-folder', tags: [] },
    { name: 'ion-ios-folder-open', tags: [] },
    { name: 'ion-ios-football', tags: [] },
    { name: 'ion-ios-funnel', tags: [] },
    { name: 'ion-ios-gift', tags: [] },
    { name: 'ion-ios-git-branch', tags: [] },
    { name: 'ion-ios-git-commit', tags: [] },
    { name: 'ion-ios-git-compare', tags: [] },
    { name: 'ion-ios-git-merge', tags: [] },
    { name: 'ion-ios-git-network', tags: [] },
    { name: 'ion-ios-git-pull-request', tags: [] },
    { name: 'ion-ios-glasses', tags: [] },
    { name: 'ion-ios-globe', tags: [] },
    { name: 'ion-ios-grid', tags: [] },
    { name: 'ion-ios-hammer', tags: [] },
    { name: 'ion-ios-hand', tags: [] },
    { name: 'ion-ios-happy', tags: [] },
    { name: 'ion-ios-headset', tags: [] },
    { name: 'ion-ios-heart', tags: [] },
    { name: 'ion-ios-heart-dislike', tags: [] },
    { name: 'ion-ios-heart-empty', tags: [] },
    { name: 'ion-ios-heart-half', tags: [] },
    { name: 'ion-ios-help', tags: [] },
    { name: 'ion-ios-help-buoy', tags: [] },
    { name: 'ion-ios-help-circle', tags: [] },
    { name: 'ion-ios-help-circle-outline', tags: [] },
    { name: 'ion-ios-home', tags: [] },
    { name: 'ion-ios-hourglass', tags: [] },
    { name: 'ion-ios-ice-cream', tags: [] },
    { name: 'ion-ios-image', tags: [] },
    { name: 'ion-ios-images', tags: [] },
    { name: 'ion-ios-infinite', tags: [] },
    { name: 'ion-ios-information', tags: [] },
    { name: 'ion-ios-information-circle', tags: [] },
    { name: 'ion-ios-information-circle-outline', tags: [] },
    { name: 'ion-ios-jet', tags: [] },
    { name: 'ion-ios-journal', tags: [] },
    { name: 'ion-ios-key', tags: [] },
    { name: 'ion-ios-keypad', tags: [] },
    { name: 'ion-ios-laptop', tags: [] },
    { name: 'ion-ios-leaf', tags: [] },
    { name: 'ion-ios-link', tags: [] },
    { name: 'ion-ios-list', tags: [] },
    { name: 'ion-ios-list-box', tags: [] },
    { name: 'ion-ios-locate', tags: [] },
    { name: 'ion-ios-lock', tags: [] },
    { name: 'ion-ios-log-in', tags: [] },
    { name: 'ion-ios-log-out', tags: [] },
    { name: 'ion-ios-magnet', tags: [] },
    { name: 'ion-ios-mail', tags: [] },
    { name: 'ion-ios-mail-open', tags: [] },
    { name: 'ion-ios-mail-unread', tags: [] },
    { name: 'ion-ios-male', tags: [] },
    { name: 'ion-ios-man', tags: [] },
    { name: 'ion-ios-map', tags: [] },
    { name: 'ion-ios-medal', tags: [] },
    { name: 'ion-ios-medical', tags: [] },
    { name: 'ion-ios-medkit', tags: [] },
    { name: 'ion-ios-megaphone', tags: [] },
    { name: 'ion-ios-menu', tags: [] },
    { name: 'ion-ios-mic', tags: [] },
    { name: 'ion-ios-mic-off', tags: [] },
    { name: 'ion-ios-microphone', tags: [] },
    { name: 'ion-ios-moon', tags: [] },
    { name: 'ion-ios-more', tags: [] },
    { name: 'ion-ios-move', tags: [] },
    { name: 'ion-ios-musical-note', tags: [] },
    { name: 'ion-ios-musical-notes', tags: [] },
    { name: 'ion-ios-navigate', tags: [] },
    { name: 'ion-ios-notifications', tags: [] },
    { name: 'ion-ios-notifications-off', tags: [] },
    { name: 'ion-ios-notifications-outline', tags: [] },
    { name: 'ion-ios-nuclear', tags: [] },
    { name: 'ion-ios-nutrition', tags: [] },
    { name: 'ion-ios-open', tags: [] },
    { name: 'ion-ios-options', tags: [] },
    { name: 'ion-ios-outlet', tags: [] },
    { name: 'ion-ios-paper', tags: [] },
    { name: 'ion-ios-paper-plane', tags: [] },
    { name: 'ion-ios-partly-sunny', tags: [] },
    { name: 'ion-ios-pause', tags: [] },
    { name: 'ion-ios-paw', tags: [] },
    { name: 'ion-ios-people', tags: [] },
    { name: 'ion-ios-person', tags: [] },
    { name: 'ion-ios-person-add', tags: [] },
    { name: 'ion-ios-phone-landscape', tags: [] },
    { name: 'ion-ios-phone-portrait', tags: [] },
    { name: 'ion-ios-photos', tags: [] },
    { name: 'ion-ios-pie', tags: [] },
    { name: 'ion-ios-pin', tags: [] },
    { name: 'ion-ios-pint', tags: [] },
    { name: 'ion-ios-pizza', tags: [] },
    { name: 'ion-ios-planet', tags: [] },
    { name: 'ion-ios-play', tags: [] },
    { name: 'ion-ios-play-circle', tags: [] },
    { name: 'ion-ios-podium', tags: [] },
    { name: 'ion-ios-power', tags: [] },
    { name: 'ion-ios-pricetag', tags: [] },
    { name: 'ion-ios-pricetags', tags: [] },
    { name: 'ion-ios-print', tags: [] },
    { name: 'ion-ios-pulse', tags: [] },
    { name: 'ion-ios-qr-scanner', tags: [] },
    { name: 'ion-ios-quote', tags: [] },
    { name: 'ion-ios-radio', tags: [] },
    { name: 'ion-ios-radio-button-off', tags: [] },
    { name: 'ion-ios-radio-button-on', tags: [] },
    { name: 'ion-ios-rainy', tags: [] },
    { name: 'ion-ios-recording', tags: [] },
    { name: 'ion-ios-redo', tags: [] },
    { name: 'ion-ios-refresh', tags: [] },
    { name: 'ion-ios-refresh-circle', tags: [] },
    { name: 'ion-ios-remove', tags: [] },
    { name: 'ion-ios-remove-circle', tags: [] },
    { name: 'ion-ios-remove-circle-outline', tags: [] },
    { name: 'ion-ios-reorder', tags: [] },
    { name: 'ion-ios-repeat', tags: [] },
    { name: 'ion-ios-resize', tags: [] },
    { name: 'ion-ios-restaurant', tags: [] },
    { name: 'ion-ios-return-left', tags: [] },
    { name: 'ion-ios-return-right', tags: [] },
    { name: 'ion-ios-reverse-camera', tags: [] },
    { name: 'ion-ios-rewind', tags: [] },
    { name: 'ion-ios-ribbon', tags: [] },
    { name: 'ion-ios-rocket', tags: [] },
    { name: 'ion-ios-rose', tags: [] },
    { name: 'ion-ios-sad', tags: [] },
    { name: 'ion-ios-save', tags: [] },
    { name: 'ion-ios-school', tags: [] },
    { name: 'ion-ios-search', tags: [] },
    { name: 'ion-ios-send', tags: [] },
    { name: 'ion-ios-settings', tags: [] },
    { name: 'ion-ios-share', tags: [] },
    { name: 'ion-ios-share-alt', tags: [] },
    { name: 'ion-ios-shirt', tags: [] },
    { name: 'ion-ios-shuffle', tags: [] },
    { name: 'ion-ios-skip-backward', tags: [] },
    { name: 'ion-ios-skip-forward', tags: [] },
    { name: 'ion-ios-snow', tags: [] },
    { name: 'ion-ios-speedometer', tags: [] },
    { name: 'ion-ios-square', tags: [] },
    { name: 'ion-ios-square-outline', tags: [] },
    { name: 'ion-ios-star', tags: [] },
    { name: 'ion-ios-star-half', tags: [] },
    { name: 'ion-ios-star-outline', tags: [] },
    { name: 'ion-ios-stats', tags: [] },
    { name: 'ion-ios-stopwatch', tags: [] },
    { name: 'ion-ios-subway', tags: [] },
    { name: 'ion-ios-sunny', tags: [] },
    { name: 'ion-ios-swap', tags: [] },
    { name: 'ion-ios-switch', tags: [] },
    { name: 'ion-ios-sync', tags: [] },
    { name: 'ion-ios-tablet-landscape', tags: [] },
    { name: 'ion-ios-tablet-portrait', tags: [] },
    { name: 'ion-ios-tennisball', tags: [] },
    { name: 'ion-ios-text', tags: [] },
    { name: 'ion-ios-thermometer', tags: [] },
    { name: 'ion-ios-thumbs-down', tags: [] },
    { name: 'ion-ios-thumbs-up', tags: [] },
    { name: 'ion-ios-thunderstorm', tags: [] },
    { name: 'ion-ios-time', tags: [] },
    { name: 'ion-ios-timer', tags: [] },
    { name: 'ion-ios-today', tags: [] },
    { name: 'ion-ios-train', tags: [] },
    { name: 'ion-ios-transgender', tags: [] },
    { name: 'ion-ios-trash', tags: [] },
    { name: 'ion-ios-trending-down', tags: [] },
    { name: 'ion-ios-trending-up', tags: [] },
    { name: 'ion-ios-trophy', tags: [] },
    { name: 'ion-ios-tv', tags: [] },
    { name: 'ion-ios-umbrella', tags: [] },
    { name: 'ion-ios-undo', tags: [] },
    { name: 'ion-ios-unlock', tags: [] },
    { name: 'ion-ios-videocam', tags: [] },
    { name: 'ion-ios-volume-high', tags: [] },
    { name: 'ion-ios-volume-low', tags: [] },
    { name: 'ion-ios-volume-mute', tags: [] },
    { name: 'ion-ios-volume-off', tags: [] },
    { name: 'ion-ios-walk', tags: [] },
    { name: 'ion-ios-wallet', tags: [] },
    { name: 'ion-ios-warning', tags: [] },
    { name: 'ion-ios-watch', tags: [] },
    { name: 'ion-ios-water', tags: [] },
    { name: 'ion-ios-wifi', tags: [] },
    { name: 'ion-ios-wine', tags: [] },
    { name: 'ion-ios-woman', tags: [] },
    { name: 'ion-logo-android', tags: [] },
    { name: 'ion-logo-angular', tags: [] },
    { name: 'ion-logo-apple', tags: [] },
    { name: 'ion-logo-bitbucket', tags: [] },
    { name: 'ion-logo-bitcoin', tags: [] },
    { name: 'ion-logo-buffer', tags: [] },
    { name: 'ion-logo-chrome', tags: [] },
    { name: 'ion-logo-closed-captioning', tags: [] },
    { name: 'ion-logo-codepen', tags: [] },
    { name: 'ion-logo-css3', tags: [] },
    { name: 'ion-logo-designernews', tags: [] },
    { name: 'ion-logo-dribbble', tags: [] },
    { name: 'ion-logo-dropbox', tags: [] },
    { name: 'ion-logo-euro', tags: [] },
    { name: 'ion-logo-facebook', tags: [] },
    { name: 'ion-logo-flickr', tags: [] },
    { name: 'ion-logo-foursquare', tags: [] },
    { name: 'ion-logo-freebsd-devil', tags: [] },
    { name: 'ion-logo-game-controller-a', tags: [] },
    { name: 'ion-logo-game-controller-b', tags: [] },
    { name: 'ion-logo-github', tags: [] },
    { name: 'ion-logo-google', tags: [] },
    { name: 'ion-logo-googleplus', tags: [] },
    { name: 'ion-logo-hackernews', tags: [] },
    { name: 'ion-logo-html5', tags: [] },
    { name: 'ion-logo-instagram', tags: [] },
    { name: 'ion-logo-ionic', tags: [] },
    { name: 'ion-logo-ionitron', tags: [] },
    { name: 'ion-logo-javascript', tags: [] },
    { name: 'ion-logo-linkedin', tags: [] },
    { name: 'ion-logo-markdown', tags: [] },
    { name: 'ion-logo-model-s', tags: [] },
    { name: 'ion-logo-no-smoking', tags: [] },
    { name: 'ion-logo-nodejs', tags: [] },
    { name: 'ion-logo-npm', tags: [] },
    { name: 'ion-logo-octocat', tags: [] },
    { name: 'ion-logo-pinterest', tags: [] },
    { name: 'ion-logo-playstation', tags: [] },
    { name: 'ion-logo-polymer', tags: [] },
    { name: 'ion-logo-python', tags: [] },
    { name: 'ion-logo-reddit', tags: [] },
    { name: 'ion-logo-rss', tags: [] },
    { name: 'ion-logo-sass', tags: [] },
    { name: 'ion-logo-skype', tags: [] },
    { name: 'ion-logo-slack', tags: [] },
    { name: 'ion-logo-snapchat', tags: [] },
    { name: 'ion-logo-steam', tags: [] },
    { name: 'ion-logo-tumblr', tags: [] },
    { name: 'ion-logo-tux', tags: [] },
    { name: 'ion-logo-twitch', tags: [] },
    { name: 'ion-logo-twitter', tags: [] },
    { name: 'ion-logo-usd', tags: [] },
    { name: 'ion-logo-vimeo', tags: [] },
    { name: 'ion-logo-vk', tags: [] },
    { name: 'ion-logo-whatsapp', tags: [] },
    { name: 'ion-logo-windows', tags: [] },
    { name: 'ion-logo-wordpress', tags: [] },
    { name: 'ion-logo-xbox', tags: [] },
    { name: 'ion-logo-xing', tags: [] },
    { name: 'ion-logo-yahoo', tags: [] },
    { name: 'ion-logo-yen', tags: [] },
    { name: 'ion-logo-youtube', tags: [] },
    { name: 'ion-md-add', tags: [] },
    { name: 'ion-md-add-circle', tags: [] },
    { name: 'ion-md-add-circle-outline', tags: [] },
    { name: 'ion-md-airplane', tags: [] },
    { name: 'ion-md-alarm', tags: [] },
    { name: 'ion-md-albums', tags: [] },
    { name: 'ion-md-alert', tags: [] },
    { name: 'ion-md-american-football', tags: [] },
    { name: 'ion-md-analytics', tags: [] },
    { name: 'ion-md-aperture', tags: [] },
    { name: 'ion-md-apps', tags: [] },
    { name: 'ion-md-appstore', tags: [] },
    { name: 'ion-md-archive', tags: [] },
    { name: 'ion-md-arrow-back', tags: [] },
    { name: 'ion-md-arrow-down', tags: [] },
    { name: 'ion-md-arrow-dropdown', tags: [] },
    { name: 'ion-md-arrow-dropdown-circle', tags: [] },
    { name: 'ion-md-arrow-dropleft', tags: [] },
    { name: 'ion-md-arrow-dropleft-circle', tags: [] },
    { name: 'ion-md-arrow-dropright', tags: [] },
    { name: 'ion-md-arrow-dropright-circle', tags: [] },
    { name: 'ion-md-arrow-dropup', tags: [] },
    { name: 'ion-md-arrow-dropup-circle', tags: [] },
    { name: 'ion-md-arrow-forward', tags: [] },
    { name: 'ion-md-arrow-round-back', tags: [] },
    { name: 'ion-md-arrow-round-down', tags: [] },
    { name: 'ion-md-arrow-round-forward', tags: [] },
    { name: 'ion-md-arrow-round-up', tags: [] },
    { name: 'ion-md-arrow-up', tags: [] },
    { name: 'ion-md-at', tags: [] },
    { name: 'ion-md-attach', tags: [] },
    { name: 'ion-md-backspace', tags: [] },
    { name: 'ion-md-barcode', tags: [] },
    { name: 'ion-md-baseball', tags: [] },
    { name: 'ion-md-basket', tags: [] },
    { name: 'ion-md-basketball', tags: [] },
    { name: 'ion-md-battery-charging', tags: [] },
    { name: 'ion-md-battery-dead', tags: [] },
    { name: 'ion-md-battery-full', tags: [] },
    { name: 'ion-md-beaker', tags: [] },
    { name: 'ion-md-bed', tags: [] },
    { name: 'ion-md-beer', tags: [] },
    { name: 'ion-md-bicycle', tags: [] },
    { name: 'ion-md-bluetooth', tags: [] },
    { name: 'ion-md-boat', tags: [] },
    { name: 'ion-md-body', tags: [] },
    { name: 'ion-md-bonfire', tags: [] },
    { name: 'ion-md-book', tags: [] },
    { name: 'ion-md-bookmark', tags: [] },
    { name: 'ion-md-bookmarks', tags: [] },
    { name: 'ion-md-bowtie', tags: [] },
    { name: 'ion-md-briefcase', tags: [] },
    { name: 'ion-md-browsers', tags: [] },
    { name: 'ion-md-brush', tags: [] },
    { name: 'ion-md-bug', tags: [] },
    { name: 'ion-md-build', tags: [] },
    { name: 'ion-md-bulb', tags: [] },
    { name: 'ion-md-bus', tags: [] },
    { name: 'ion-md-business', tags: [] },
    { name: 'ion-md-cafe', tags: [] },
    { name: 'ion-md-calculator', tags: [] },
    { name: 'ion-md-calendar', tags: [] },
    { name: 'ion-md-call', tags: [] },
    { name: 'ion-md-camera', tags: [] },
    { name: 'ion-md-car', tags: [] },
    { name: 'ion-md-card', tags: [] },
    { name: 'ion-md-cart', tags: [] },
    { name: 'ion-md-cash', tags: [] },
    { name: 'ion-md-cellular', tags: [] },
    { name: 'ion-md-chatboxes', tags: [] },
    { name: 'ion-md-chatbubbles', tags: [] },
    { name: 'ion-md-checkbox', tags: [] },
    { name: 'ion-md-checkbox-outline', tags: [] },
    { name: 'ion-md-checkmark', tags: [] },
    { name: 'ion-md-checkmark-circle', tags: [] },
    { name: 'ion-md-checkmark-circle-outline', tags: [] },
    { name: 'ion-md-clipboard', tags: [] },
    { name: 'ion-md-clock', tags: [] },
    { name: 'ion-md-close', tags: [] },
    { name: 'ion-md-close-circle', tags: [] },
    { name: 'ion-md-close-circle-outline', tags: [] },
    { name: 'ion-md-cloud', tags: [] },
    { name: 'ion-md-cloud-circle', tags: [] },
    { name: 'ion-md-cloud-done', tags: [] },
    { name: 'ion-md-cloud-download', tags: [] },
    { name: 'ion-md-cloud-outline', tags: [] },
    { name: 'ion-md-cloud-upload', tags: [] },
    { name: 'ion-md-cloudy', tags: [] },
    { name: 'ion-md-cloudy-night', tags: [] },
    { name: 'ion-md-code', tags: [] },
    { name: 'ion-md-code-download', tags: [] },
    { name: 'ion-md-code-working', tags: [] },
    { name: 'ion-md-cog', tags: [] },
    { name: 'ion-md-color-fill', tags: [] },
    { name: 'ion-md-color-filter', tags: [] },
    { name: 'ion-md-color-palette', tags: [] },
    { name: 'ion-md-color-wand', tags: [] },
    { name: 'ion-md-compass', tags: [] },
    { name: 'ion-md-construct', tags: [] },
    { name: 'ion-md-contact', tags: [] },
    { name: 'ion-md-contacts', tags: [] },
    { name: 'ion-md-contract', tags: [] },
    { name: 'ion-md-contrast', tags: [] },
    { name: 'ion-md-copy', tags: [] },
    { name: 'ion-md-create', tags: [] },
    { name: 'ion-md-crop', tags: [] },
    { name: 'ion-md-cube', tags: [] },
    { name: 'ion-md-cut', tags: [] },
    { name: 'ion-md-desktop', tags: [] },
    { name: 'ion-md-disc', tags: [] },
    { name: 'ion-md-document', tags: [] },
    { name: 'ion-md-done-all', tags: [] },
    { name: 'ion-md-download', tags: [] },
    { name: 'ion-md-easel', tags: [] },
    { name: 'ion-md-egg', tags: [] },
    { name: 'ion-md-exit', tags: [] },
    { name: 'ion-md-expand', tags: [] },
    { name: 'ion-md-eye', tags: [] },
    { name: 'ion-md-eye-off', tags: [] },
    { name: 'ion-md-fastforward', tags: [] },
    { name: 'ion-md-female', tags: [] },
    { name: 'ion-md-filing', tags: [] },
    { name: 'ion-md-film', tags: [] },
    { name: 'ion-md-finger-print', tags: [] },
    { name: 'ion-md-fitness', tags: [] },
    { name: 'ion-md-flag', tags: [] },
    { name: 'ion-md-flame', tags: [] },
    { name: 'ion-md-flash', tags: [] },
    { name: 'ion-md-flash-off', tags: [] },
    { name: 'ion-md-flashlight', tags: [] },
    { name: 'ion-md-flask', tags: [] },
    { name: 'ion-md-flower', tags: [] },
    { name: 'ion-md-folder', tags: [] },
    { name: 'ion-md-folder-open', tags: [] },
    { name: 'ion-md-football', tags: [] },
    { name: 'ion-md-funnel', tags: [] },
    { name: 'ion-md-gift', tags: [] },
    { name: 'ion-md-git-branch', tags: [] },
    { name: 'ion-md-git-commit', tags: [] },
    { name: 'ion-md-git-compare', tags: [] },
    { name: 'ion-md-git-merge', tags: [] },
    { name: 'ion-md-git-network', tags: [] },
    { name: 'ion-md-git-pull-request', tags: [] },
    { name: 'ion-md-glasses', tags: [] },
    { name: 'ion-md-globe', tags: [] },
    { name: 'ion-md-grid', tags: [] },
    { name: 'ion-md-hammer', tags: [] },
    { name: 'ion-md-hand', tags: [] },
    { name: 'ion-md-happy', tags: [] },
    { name: 'ion-md-headset', tags: [] },
    { name: 'ion-md-heart', tags: [] },
    { name: 'ion-md-heart-dislike', tags: [] },
    { name: 'ion-md-heart-empty', tags: [] },
    { name: 'ion-md-heart-half', tags: [] },
    { name: 'ion-md-help', tags: [] },
    { name: 'ion-md-help-buoy', tags: [] },
    { name: 'ion-md-help-circle', tags: [] },
    { name: 'ion-md-help-circle-outline', tags: [] },
    { name: 'ion-md-home', tags: [] },
    { name: 'ion-md-hourglass', tags: [] },
    { name: 'ion-md-ice-cream', tags: [] },
    { name: 'ion-md-image', tags: [] },
    { name: 'ion-md-images', tags: [] },
    { name: 'ion-md-infinite', tags: [] },
    { name: 'ion-md-information', tags: [] },
    { name: 'ion-md-information-circle', tags: [] },
    { name: 'ion-md-information-circle-outline', tags: [] },
    { name: 'ion-md-jet', tags: [] },
    { name: 'ion-md-journal', tags: [] },
    { name: 'ion-md-key', tags: [] },
    { name: 'ion-md-keypad', tags: [] },
    { name: 'ion-md-laptop', tags: [] },
    { name: 'ion-md-leaf', tags: [] },
    { name: 'ion-md-link', tags: [] },
    { name: 'ion-md-list', tags: [] },
    { name: 'ion-md-list-box', tags: [] },
    { name: 'ion-md-locate', tags: [] },
    { name: 'ion-md-lock', tags: [] },
    { name: 'ion-md-log-in', tags: [] },
    { name: 'ion-md-log-out', tags: [] },
    { name: 'ion-md-magnet', tags: [] },
    { name: 'ion-md-mail', tags: [] },
    { name: 'ion-md-mail-open', tags: [] },
    { name: 'ion-md-mail-unread', tags: [] },
    { name: 'ion-md-male', tags: [] },
    { name: 'ion-md-man', tags: [] },
    { name: 'ion-md-map', tags: [] },
    { name: 'ion-md-medal', tags: [] },
    { name: 'ion-md-medical', tags: [] },
    { name: 'ion-md-medkit', tags: [] },
    { name: 'ion-md-megaphone', tags: [] },
    { name: 'ion-md-menu', tags: [] },
    { name: 'ion-md-mic', tags: [] },
    { name: 'ion-md-mic-off', tags: [] },
    { name: 'ion-md-microphone', tags: [] },
    { name: 'ion-md-moon', tags: [] },
    { name: 'ion-md-more', tags: [] },
    { name: 'ion-md-move', tags: [] },
    { name: 'ion-md-musical-note', tags: [] },
    { name: 'ion-md-musical-notes', tags: [] },
    { name: 'ion-md-navigate', tags: [] },
    { name: 'ion-md-notifications', tags: [] },
    { name: 'ion-md-notifications-off', tags: [] },
    { name: 'ion-md-notifications-outline', tags: [] },
    { name: 'ion-md-nuclear', tags: [] },
    { name: 'ion-md-nutrition', tags: [] },
    { name: 'ion-md-open', tags: [] },
    { name: 'ion-md-options', tags: [] },
    { name: 'ion-md-outlet', tags: [] },
    { name: 'ion-md-paper', tags: [] },
    { name: 'ion-md-paper-plane', tags: [] },
    { name: 'ion-md-partly-sunny', tags: [] },
    { name: 'ion-md-pause', tags: [] },
    { name: 'ion-md-paw', tags: [] },
    { name: 'ion-md-people', tags: [] },
    { name: 'ion-md-person', tags: [] },
    { name: 'ion-md-person-add', tags: [] },
    { name: 'ion-md-phone-landscape', tags: [] },
    { name: 'ion-md-phone-portrait', tags: [] },
    { name: 'ion-md-photos', tags: [] },
    { name: 'ion-md-pie', tags: [] },
    { name: 'ion-md-pin', tags: [] },
    { name: 'ion-md-pint', tags: [] },
    { name: 'ion-md-pizza', tags: [] },
    { name: 'ion-md-planet', tags: [] },
    { name: 'ion-md-play', tags: [] },
    { name: 'ion-md-play-circle', tags: [] },
    { name: 'ion-md-podium', tags: [] },
    { name: 'ion-md-power', tags: [] },
    { name: 'ion-md-pricetag', tags: [] },
    { name: 'ion-md-pricetags', tags: [] },
    { name: 'ion-md-print', tags: [] },
    { name: 'ion-md-pulse', tags: [] },
    { name: 'ion-md-qr-scanner', tags: [] },
    { name: 'ion-md-quote', tags: [] },
    { name: 'ion-md-radio', tags: [] },
    { name: 'ion-md-radio-button-off', tags: [] },
    { name: 'ion-md-radio-button-on', tags: [] },
    { name: 'ion-md-rainy', tags: [] },
    { name: 'ion-md-recording', tags: [] },
    { name: 'ion-md-redo', tags: [] },
    { name: 'ion-md-refresh', tags: [] },
    { name: 'ion-md-refresh-circle', tags: [] },
    { name: 'ion-md-remove', tags: [] },
    { name: 'ion-md-remove-circle', tags: [] },
    { name: 'ion-md-remove-circle-outline', tags: [] },
    { name: 'ion-md-reorder', tags: [] },
    { name: 'ion-md-repeat', tags: [] },
    { name: 'ion-md-resize', tags: [] },
    { name: 'ion-md-restaurant', tags: [] },
    { name: 'ion-md-return-left', tags: [] },
    { name: 'ion-md-return-right', tags: [] },
    { name: 'ion-md-reverse-camera', tags: [] },
    { name: 'ion-md-rewind', tags: [] },
    { name: 'ion-md-ribbon', tags: [] },
    { name: 'ion-md-rocket', tags: [] },
    { name: 'ion-md-rose', tags: [] },
    { name: 'ion-md-sad', tags: [] },
    { name: 'ion-md-save', tags: [] },
    { name: 'ion-md-school', tags: [] },
    { name: 'ion-md-search', tags: [] },
    { name: 'ion-md-send', tags: [] },
    { name: 'ion-md-settings', tags: [] },
    { name: 'ion-md-share', tags: [] },
    { name: 'ion-md-share-alt', tags: [] },
    { name: 'ion-md-shirt', tags: [] },
    { name: 'ion-md-shuffle', tags: [] },
    { name: 'ion-md-skip-backward', tags: [] },
    { name: 'ion-md-skip-forward', tags: [] },
    { name: 'ion-md-snow', tags: [] },
    { name: 'ion-md-speedometer', tags: [] },
    { name: 'ion-md-square', tags: [] },
    { name: 'ion-md-square-outline', tags: [] },
    { name: 'ion-md-star', tags: [] },
    { name: 'ion-md-star-half', tags: [] },
    { name: 'ion-md-star-outline', tags: [] },
    { name: 'ion-md-stats', tags: [] },
    { name: 'ion-md-stopwatch', tags: [] },
    { name: 'ion-md-subway', tags: [] },
    { name: 'ion-md-sunny', tags: [] },
    { name: 'ion-md-swap', tags: [] },
    { name: 'ion-md-switch', tags: [] },
    { name: 'ion-md-sync', tags: [] },
    { name: 'ion-md-tablet-landscape', tags: [] },
    { name: 'ion-md-tablet-portrait', tags: [] },
    { name: 'ion-md-tennisball', tags: [] },
    { name: 'ion-md-text', tags: [] },
    { name: 'ion-md-thermometer', tags: [] },
    { name: 'ion-md-thumbs-down', tags: [] },
    { name: 'ion-md-thumbs-up', tags: [] },
    { name: 'ion-md-thunderstorm', tags: [] },
    { name: 'ion-md-time', tags: [] },
    { name: 'ion-md-timer', tags: [] },
    { name: 'ion-md-today', tags: [] },
    { name: 'ion-md-train', tags: [] },
    { name: 'ion-md-transgender', tags: [] },
    { name: 'ion-md-trash', tags: [] },
    { name: 'ion-md-trending-down', tags: [] },
    { name: 'ion-md-trending-up', tags: [] },
    { name: 'ion-md-trophy', tags: [] },
    { name: 'ion-md-tv', tags: [] },
    { name: 'ion-md-umbrella', tags: [] },
    { name: 'ion-md-undo', tags: [] },
    { name: 'ion-md-unlock', tags: [] },
    { name: 'ion-md-videocam', tags: [] },
    { name: 'ion-md-volume-high', tags: [] },
    { name: 'ion-md-volume-low', tags: [] },
    { name: 'ion-md-volume-mute', tags: [] },
    { name: 'ion-md-volume-off', tags: [] },
    { name: 'ion-md-walk', tags: [] },
    { name: 'ion-md-wallet', tags: [] },
    { name: 'ion-md-warning', tags: [] },
    { name: 'ion-md-watch', tags: [] },
    { name: 'ion-md-water', tags: [] },
    { name: 'ion-md-wifi', tags: [] },
    { name: 'ion-md-wine', tags: [] },
    { name: 'ion-md-woman', tags: [] }
  ]
}
